import { Button, ComboboxItem } from '@mantine/core';
import { IconFileTypeXls } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Id } from '@feature/utils';
import { ValidationStatus } from '@feature/validation';

export interface AnnualReportDownloadXlsxButtonProps {
  year: number;
  validationStatus: ValidationStatus | null;
  faculty: ComboboxItem | null;
  userId: Id | null;
}

const onDownload = (
  year: number,
  validationStatus: ValidationStatus | null,
  faculty: ComboboxItem | null,
  userId: Id | null,
) => {
  const userQuery = userId != null ? `&userId=${userId}` : '';
  const validationQuery = validationStatus != null ? `&validationStatus=${validationStatus}` : '';
  const facultyQuery = faculty != null ? `&facultyId=${Number(faculty.value)}` : '';
  window.open(
    `/api/annual-report/generate/technological-transfers-report/${year}?${userQuery}${validationQuery}${facultyQuery}`,
  );
};

export const AnnualReportTechnologicalTransfersDownloadXlsxButton = (props: AnnualReportDownloadXlsxButtonProps) => {
  const { year, validationStatus, faculty, userId } = props;
  const { t } = useTranslation();

  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeXls size="24px" />}
      onClick={() => onDownload(year, validationStatus, faculty, userId)}
    >
      {t('technologicalTransfers.annualReport')}
    </Button>
  );
};
